import React from "react";

const Faq = () => {
  return (
    <div className="flex flex-col lg:flex-row justify-center">
      <div className=" text-white py-32">
        <div className="py-4 max-w-3xl mx-auto bg-slate-900 p-8 rounded-lg shadow-lg">
          <h1 className="text-3xl font-bold mb-4">
            Frequently Asked Questions
          </h1>
          <h3 className="text-xl font-bold"> When can I watch live games?</h3>
          <p className="mb-8 text-gray-400">
            For each game's schedule, please visit the{" "}
            <a
              className="text-blue-600"
              href="https://www.ofcfootball.ca/leagues/schedules.cfm?clientid=6862&leagueid=32823"
            >
              ofcfootball.ca
            </a>{" "}
            website. Streams usually start 15 minutes prior to kickoff. A
            refresh of the page may be required to view the live stream.
          </p>
          <h3 className="text-xl font-bold">
            {" "}
            When can I watch archived games?
          </h3>
          <p className="mb-8 text-gray-400">
            Game archives or video on demand are posted as soon as possible
            after the game has finished but may take additional time.
          </p>
          <h3 className="text-xl font-bold"> How do I watch games?</h3>
          <p className="mb-8 text-gray-400">
            Click on the thumbnail of the team you'd like to watch on the{" "}
            <a className="text-blue-600" href="/">
              Homepage
            </a>{" "}
            If the game is live, the video player should load automatically and
            you are required to press play. For videos on demand, click the game
            you'd like to watch. Video on demand archives are sorted by most
            recent date.
          </p>
          <h3 className="text-xl font-bold">
            {" "}
            How do I watch pay per view games?
          </h3>
          <p className="mb-8 text-gray-400">
            Click on the thumbnail of the pay per view event you'd like to
            watch. Clicking on the video will prompt you to purchase a ticket or
            view more information on the purchase. Clicking "Buy Now" will show
            you instructions and send you to the payment website.
          </p>
          <p className="mb-8 text-gray-400">
            Disclaimer: Our service is provided on an "as is" basis. While we
            strive to deliver a seamless streaming experience, please be aware
            that streaming issues may arise beyond our control or on the
            viewer's end. We cannot be held liable for the quality,
            cancellation, or discontinuation of any event, nor for the failure
            to broadcast an event as scheduled or advertised. Additionally, we
            are not responsible if you encounter difficulties accessing events
            on specific devices. Please note that all pay-per-view sales are
            final.
          </p>
          <h3 className="text-xl font-bold">
            {" "}
            How many pay per view plays am I allowed?
          </h3>
          <p className="mb-8 text-gray-400">
            For live games, we have unlimited views and plays per ticket,
            however VOD plays may be limited. A play is when a viewer clicks on
            the play button and starts watching the video or live stream.
          </p>
          <h3 className="text-xl font-bold">
            {" "}
            How do I know when a pay per view event is live?
          </h3>
          <p className="mb-8 text-gray-400">
            Pay per view events will show up with the red "LIVE" label in the
            top right hand corner of the thumbnail, however when you enter that
            page there will be no further "LIVE" label like non pay per view
            events. Pay per view events should be live approximately 15 minutes
            before kickoff.
          </p>
          <h3 className="text-xl font-bold">
            {" "}
            Are you experiencing issues with pay per view live streams?
          </h3>
          <p className="mb-8 text-gray-400">
            If you are presented with a spinning loading icon on the player
            after entering your ticket password or ticket purchase, please wait
            a minute for it to load. If this continues, please try opening the
            page in a new browser or incognito mode of your current browser.
          </p>
          <h3 className="text-xl font-bold">
            {" "}
            Where do I find my ticket password?{" "}
          </h3>
          <p className="mb-8 text-gray-400">
            Your ticket password will be emailed to you once a payment has been
            made. The email will be titled "Thank you for purchasing a PPV
            ticket" from the email address "no_reply@ppvmailer.com". If you have
            not received an email, please check your spam folder or{" "}
            <a classname="text-blue-600" href="mailto:support@isilive.ca">
              contact us
            </a>{" "}
            to resend your ticket.
          </p>
          <h3 className="text-xl font-bold"> Other questions or concerns</h3>
          <p className="mb-8 text-gray-400">
            If you have any other questions or concerns, please contact us at{" "}
            <a href="mailto:support@isilive.ca">support@isilive.ca</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Faq;
